import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import React from "react";

export const CenteredLoadingSpinner: React.FC = () => {
  return (
    <Row justify="center" align="center">
      <LoadingSpinner />
    </Row>
  );
};
